import { Reveal } from "@/components/shared/Reveal";
import { Building2, ChevronDown, Send, MousePointerClick } from "lucide-react";

const CATEGORIES = ["Florida Drivers", "Reefer Drivers", "Dry Van Drivers", "Hazmat Drivers", "Relief Drivers", "Preferred Drivers"];

export const BrokerNetworkVisual = () => (
  <section data-testid="broker-network-visual-section" className="py-24 md:py-32 bg-rr-navy relative overflow-hidden">
    <div className="grain-overlay" />
    <div className="max-w-3xl mx-auto px-5 md:px-8 relative">
      <Reveal>
        <div className="text-center mb-14">
          <div className="text-xs font-bold tracking-[0.22em] uppercase text-rr-orangeLight mb-4">How a Private Network Flows</div>
          <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-white tracking-tight">One Broker. One Organized Network.</h2>
        </div>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="flex flex-col items-center gap-3">
          <div data-testid="broker-network-visual-broker" className="bg-rr-orange text-white font-bold px-6 py-3 rounded-full flex items-center gap-2">
            <Building2 size={16} /> Broker
          </div>
          <ChevronDown size={20} className="text-white/40" />
          <div data-testid="broker-network-visual-private-network" className="bg-white/10 border border-white/20 text-white font-bold px-6 py-3 rounded-full">
            Private Driver Network
          </div>
          <ChevronDown size={20} className="text-white/40" />

          <div className="flex flex-wrap justify-center gap-2.5 max-w-xl">
            {CATEGORIES.map((c) => (
              <span key={c} data-testid={`broker-network-visual-category-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-xs font-bold px-3.5 py-2 rounded-full bg-white/[0.06] border border-white/10 text-white/80">
                {c}
              </span>
            ))}
          </div>
          <ChevronDown size={20} className="text-white/40" />

          <div data-testid="broker-network-visual-select-driver" className="bg-white/10 border border-white/20 text-white font-bold px-6 py-3 rounded-full flex items-center gap-2">
            <MousePointerClick size={16} /> Select Driver
          </div>
          <ChevronDown size={20} className="text-white/40" />
          <div data-testid="broker-network-visual-send-opportunity" className="bg-rr-orange text-white font-bold px-6 py-3 rounded-full flex items-center gap-2">
            <Send size={16} /> Send Opportunity
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
